import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './lock-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class LockIconComponent {}
